import React from "react";
import Dropzone from "react-dropzone";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import { getValidFileName } from "@utilscommon";

export default function AnyFilesDropOnly(props) {
  var { className, displayText, accept } = props;
  // console.log("accept :- ", accept);

  const onDropFile = (files) => {
    let file = files[0];
    // console.log('file :- ', file);
    let reader = new FileReader();
    reader.onloadend = () => {
      let item = reader.result;
      let fileName = getValidFileName(file.name);
      let data = { file: item, filename: fileName };

      // console.log('data :- ', data);
      props.onFileSave(data);
    };
    reader.readAsDataURL(file);
  };

  let mimeType =
    accept && accept !== ""
      ? accept === "application/*"
        ? {
            ["application/pdf"]: [],
            ["application/vnd.ms-excel"]: [],
            ["application/vnd.ms-powerpoint"]: [],
            ["application/msword"]: [],
            ["text/plain"]: [".csv", ".sql", ".xml", ".html", ".odt", ".txt"],
            ["application/zip"]: [],
            ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]:
              [],
            ["application/vnd.openxmlformats-officedocument.presentationml.presentation"]:
              [],
            ["application/vnd.openxmlformats-officedocument.presentationml.slideshow"]:
              [],
            ["application/vnd.openxmlformats-officedocument.wordprocessingml.document"]:
              [],
          }
        : {
            [accept]: [],
          }
      : {};

  return (
    <>
      <Dropzone
        onDrop={onDropFile}
        // accept={accept ? { [accept]: [] } : {}}
        accept={mimeType}
        multiple={false}
      >
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            className={`${className} flex items-center justify-center space-x-3 w-full h-full px-3 py-3 cursor-pointer border border-default rounded-md`}
          >
            <input {...getInputProps()} />
            <ArrowUpTrayIcon className="w-5 h-5" />
            <div className="custom-text-primary-sm-normal">{displayText}</div>
          </div>
        )}
      </Dropzone>
    </>
  );
}
